import React, { useEffect } from 'react';

//helpers
import { checkValue } from 'src/components/common/helper';

//types
import { HeroScrollDownArrowProps } from '../../typings';

const HeroScrollDownArrow: React.FC<HeroScrollDownArrowProps> = (props) => {
  const { heroScrollDownArrow, heroAnchorLink, heroAnchorText } = props;
  console.log('heroAnchorLink : ', heroAnchorLink);
  const httpPattern = /https?:\/\//;
  const wwwPattern = /www\./;
  const isRelativePath = heroAnchorLink.startsWith('/');
  const hasHttp = httpPattern.test(heroAnchorLink);
  const hasWWW = wwwPattern.test(heroAnchorLink);
  const hasHttpOrWWW = hasHttp || hasWWW || isRelativePath;
  const heroArrowPos: string = '';
  let isArrowLeft = false;
  let isArrowRight = false;
  if(checkValue(heroArrowPos)){
    isArrowLeft = (heroArrowPos === 'Left') ? true : false;
    isArrowRight = (heroArrowPos === 'Right') ? true : false;
  }
  

  const handleScroll = () => {
    const heroBanner = document.querySelector('.global-hero-module-container');
    const headerOffsetHeight = document.querySelector<HTMLElement>('.header-main-container').offsetHeight;
    const sweeptakemodule = document.getElementById(`${heroAnchorLink}`);
    if (checkValue(heroBanner)) {
      if(!hasHttpOrWWW){
        setTimeout(() => {
          window.scrollTo({
            behavior: 'smooth',
            top:
              (checkValue(sweeptakemodule))?
              sweeptakemodule.getBoundingClientRect().top -
              document.body.getBoundingClientRect().top -
              headerOffsetHeight:heroBanner.parentElement.nextElementSibling.getBoundingClientRect().top - document.body.getBoundingClientRect().top - headerOffsetHeight,
          });
        }, 400);
      } else {
        if (checkValue(heroAnchorLink)){
          isRelativePath ? window.location.href = heroAnchorLink : window.open(heroAnchorLink, "_blank");
        }        
      }
    }
  };

  const setScrollArrowBottom = () => {
    if (checkValue(heroScrollDownArrow) && heroScrollDownArrow === 'True') {
      const globalHeaderElem = document.querySelector<HTMLElement>('.header-main-container');
      const globalHeaderHeight = checkValue(globalHeaderElem) ? globalHeaderElem?.offsetHeight : 128;
      const heroHeight = document.querySelector<HTMLElement>('.global-hero-section')?.offsetHeight;
      const viewPortHeight = window.innerHeight;

      let scrollArrowBottom = 0;
      if(checkValue(heroAnchorText)){
        scrollArrowBottom = 30;
      } else {
        if (heroHeight + globalHeaderHeight > viewPortHeight) {
          scrollArrowBottom = globalHeaderHeight + heroHeight - viewPortHeight + 45;
        } else {
          scrollArrowBottom = 157.06;          
        }
      }
      

      document.querySelector<HTMLElement>('.hero-scroll-down-arrow-component').style.bottom = scrollArrowBottom + 'px';
      document.querySelector<HTMLElement>('.hero-scroll-down-arrow-component').style.visibility = 'visible';
    }
  };

  useEffect(() => {
    if (window) {
      setScrollArrowBottom();

      window.addEventListener('resize', () => {
        setScrollArrowBottom();
      });

      return () => {
        window.removeEventListener('resize', () => {
          setScrollArrowBottom();
        });
      }
    }
  }, []);

  return (
    <div className={`hero-scroll-down-arrow-component 
      ${(hasHttpOrWWW ? 'external-link': '')}
      ${(isArrowLeft ? 'leftarrow' : '')} ${(isArrowRight ? 'rightarrow' : '')} 
      ${checkValue(heroAnchorText) ? 'hasarrowtxt' : ''}`}>
      <span className="scoll-down-arrow" onClick={handleScroll}>
        {checkValue(heroAnchorText) && (<span className="arrowtxt">{heroAnchorText}</span>)}
        {checkValue(heroAnchorText) && (<span className="vline"></span>)}
        <span className='leftwing'></span>
        <span className='rightwing'></span>
      </span>
    </div>
  );
};

export default HeroScrollDownArrow;
